import React, { useEffect, useMemo, useState } from "react";
import { SidePanelFormControl } from "spark-core-dx/components";

const EntityObjectEditDialog = ({ open, entityObject, entityObjectItemMetadata, onCancel, onSave }) => {
  const [editItemData, setEditItemData] = useState(null);

  useEffect(() => {
    if (entityObject?.raw) setEditItemData({ ...entityObject.raw });
    else setEditItemData(null);
  }, [entityObject]);

  const formFields = useMemo(() => {
    return Array.isArray(entityObjectItemMetadata?.Fields) ? entityObjectItemMetadata.Fields : [];
  }, [entityObjectItemMetadata]);

  const title = useMemo(() => {
    const name = entityObject?.displayName || entityObject?.objectName || "Entity Object";
    return `Edit: ${name}`;
  }, [entityObject]);

  if (!entityObjectItemMetadata) return null;

  return (
    <SidePanelFormControl
      key={(editItemData?._id ?? editItemData?.UniqueId ?? entityObject?.id ?? "entity-object-edit") + (open ? "-open" : "-closed")}
      open={open}
      title={title}
      metadata={entityObjectItemMetadata}
      formFields={formFields}
      itemData={editItemData}
      onSave={onSave}
      onCancel={onCancel}
      onUpdateSidePanel={() => {}}
      setOpenEditSidePanel={(value) => {
        if (!value) onCancel();
      }}
      setItemData={setEditItemData}
      onAnimationEnd={(event) => {
        if (editItemData && open && event.animationName === "sidePanelExit") {
          setEditItemData(null);
        }
      }}
      viewOnly={false}
    />
  );
};

export default EntityObjectEditDialog;
